import { render, staticRenderFns } from "./application-center-info.vue?vue&type=template&id=061518f7&scoped=true&"
import script from "./application-center-info.vue?vue&type=script&lang=js&"
export * from "./application-center-info.vue?vue&type=script&lang=js&"
import style0 from "./application-center-info.vue?vue&type=style&index=0&id=061518f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061518f7",
  null
  
)

export default component.exports